module.exports = {
	"job": {
		"lang": "en",
		"user_id": 46548,
		"name": "video_diary.mp3",
		"duration": 112,
		"created_at": "Fri Jul 27 20:12:19 2018",
		"id": 8856523
	},
	"speakers": [
		{
			"duration": "12.83",
			"confidence": null,
			"name": "M2",
			"time": "2.36"
		},
		{
			"duration": "0.89",
			"confidence": null,
			"name": "M1",
			"time": "16.01"
		},
		{
			"duration": "7.12",
			"confidence": null,
			"name": "F1",
			"time": "18.42"
		},
		{
			"duration": "35.94",
			"confidence": null,
			"name": "M1",
			"time": "26.77"
		},
		{
			"duration": "10.07",
			"confidence": null,
			"name": "F3",
			"time": "65.51"
		},
		{
			"duration": "31.29",
			"confidence": null,
			"name": "M2",
			"time": "78.76"
		}
	],
	"words": [
		{
			"duration": "0.20",
			"confidence": "0.820",
			"name": "I",
			"time": "2.36"
		},
		{
			"duration": "0.14",
			"confidence": "0.360",
			"name": "an",
			"time": "3.32"
		},
		{
			"duration": "0.53",
			"confidence": "0.790",
			"name": "Emsley",
			"time": "3.48"
		},
		{
			"duration": "0.51",
			"confidence": "0.970",
			"name": "26",
			"time": "7.33"
		},
		{
			"duration": "0.21",
			"confidence": "0.970",
			"name": "year",
			"time": "7.84"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "old",
			"time": "8.05"
		},
		{
			"duration": "0.42",
			"confidence": "0.650",
			"name": "they're",
			"time": "10.07"
		},
		{
			"duration": "0.79",
			"confidence": "1.000",
			"name": "starting",
			"time": "11.04"
		},
		{
			"duration": "0.03",
			"confidence": "0.990",
			"name": "a",
			"time": "12.61"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "project",
			"time": "12.64"
		},
		{
			"duration": "0.30",
			"confidence": "0.990",
			"name": "just",
			"time": "13.51"
		},
		{
			"duration": "0.06",
			"confidence": "0.980",
			"name": "to",
			"time": "14.01"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "keep",
			"time": "14.08"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "track",
			"time": "14.80"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "15.19"
		},
		{
			"duration": "0.19",
			"confidence": "0.940",
			"name": "Me",
			"time": "16.01"
		},
		{
			"duration": "0.20",
			"confidence": "0.920",
			"name": "day",
			"time": "16.20"
		},
		{
			"duration": "0.15",
			"confidence": "0.920",
			"name": "to",
			"time": "16.40"
		},
		{
			"duration": "0.31",
			"confidence": "0.930",
			"name": "day",
			"time": "16.55"
		},
		{
			"duration": "0.04",
			"confidence": "0.700",
			"name": ".",
			"time": "16.86"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "Things",
			"time": "18.42"
		},
		{
			"duration": "0.17",
			"confidence": "0.990",
			"name": "that",
			"time": "18.90"
		},
		{
			"duration": "0.09",
			"confidence": "0.700",
			"name": "are",
			"time": "19.07"
		},
		{
			"duration": "0.58",
			"confidence": "0.370",
			"name": "too",
			"time": "19.22"
		},
		{
			"duration": "0.05",
			"confidence": "0.510",
			"name": "I",
			"time": "22.64"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "suffer",
			"time": "22.98"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "from",
			"time": "23.31"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "anxiety",
			"time": "23.85"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "and",
			"time": "24.51"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "depression",
			"time": "24.72"
		},
		{
			"duration": "0.19",
			"confidence": "0.630",
			"name": ".",
			"time": "25.35"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "And",
			"time": "26.77"
		},
		{
			"duration": "0.04",
			"confidence": "0.600",
			"name": "I",
			"time": "29.12"
		},
		{
			"duration": "0.20",
			"confidence": "0.530",
			"name": "thought",
			"time": "29.36"
		},
		{
			"duration": "0.10",
			"confidence": "0.960",
			"name": "it",
			"time": "29.59"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "might",
			"time": "29.69"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "be",
			"time": "29.90"
		},
		{
			"duration": "0.03",
			"confidence": "0.990",
			"name": "a",
			"time": "30.02"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "good",
			"time": "30.08"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "idea",
			"time": "30.29"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "30.71"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "keep",
			"time": "30.83"
		},
		{
			"duration": "0.06",
			"confidence": "0.840",
			"name": "a",
			"time": "31.10"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "video",
			"time": "31.16"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "diary",
			"time": "31.55"
		},
		{
			"duration": "0.07",
			"confidence": "0.650",
			"name": "to",
			"time": "32.21"
		},
		{
			"duration": "0.20",
			"confidence": "0.700",
			"name": "have",
			"time": "32.31"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": "a",
			"time": "32.54"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "little",
			"time": "32.57"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "reflection",
			"time": "32.81"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "on",
			"time": "33.92"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "myself",
			"time": "34.04"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "and",
			"time": "34.79"
		},
		{
			"duration": "0.49",
			"confidence": "0.410",
			"name": "Camilla",
			"time": "35.19"
		},
		{
			"duration": "0.22",
			"confidence": "0.590",
			"name": "and",
			"time": "37.35"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "get",
			"time": "37.72"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "the",
			"time": "37.90"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "message",
			"time": "37.96"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "out",
			"time": "38.41"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "there",
			"time": "38.59"
		},
		{
			"duration": "0.11",
			"confidence": "0.520",
			"name": ".",
			"time": "38.86"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "Make",
			"time": "39.07"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "friends",
			"time": "39.28"
		},
		{
			"duration": "0.29",
			"confidence": "0.830",
			"name": "seek",
			"time": "40.56"
		},
		{
			"duration": "0.47",
			"confidence": "0.970",
			"name": "comfort",
			"time": "40.92"
		},
		{
			"duration": "0.13",
			"confidence": "0.750",
			"name": "in",
			"time": "41.40"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "others",
			"time": "41.53"
		},
		{
			"duration": "0.02",
			"confidence": "0.620",
			"name": ".",
			"time": "42.10"
		},
		{
			"duration": "0.03",
			"confidence": "0.540",
			"name": "I",
			"time": "42.96"
		},
		{
			"duration": "0.32",
			"confidence": "0.910",
			"name": "have",
			"time": "43.19"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "an",
			"time": "44.00"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "amazing",
			"time": "44.12"
		},
		{
			"duration": "0.63",
			"confidence": "0.990",
			"name": "fiancee",
			"time": "44.63"
		},
		{
			"duration": "0.03",
			"confidence": "0.810",
			"name": ".",
			"time": "45.26"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "She",
			"time": "45.87"
		},
		{
			"duration": "0.12",
			"confidence": "0.870",
			"name": "is",
			"time": "47.21"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "always",
			"time": "47.33"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "there",
			"time": "47.60"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "when",
			"time": "47.75"
		},
		{
			"duration": "0.06",
			"confidence": "0.990",
			"name": "I",
			"time": "47.93"
		},
		{
			"duration": "0.30",
			"confidence": "0.980",
			"name": "need",
			"time": "47.99"
		},
		{
			"duration": "0.36",
			"confidence": "0.510",
			"name": "a",
			"time": "48.29"
		},
		{
			"duration": "0.04",
			"confidence": "0.750",
			"name": "I",
			"time": "51.33"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "feel",
			"time": "51.54"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "like",
			"time": "51.72"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "52.41"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "feel",
			"time": "52.50"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "like",
			"time": "52.68"
		},
		{
			"duration": "0.09",
			"confidence": "0.880",
			"name": "I've",
			"time": "52.89"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "just",
			"time": "52.98"
		},
		{
			"duration": "0.21",
			"confidence": "0.930",
			"name": "learned",
			"time": "53.16"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "to",
			"time": "53.37"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "move",
			"time": "53.55"
		},
		{
			"duration": "0.20",
			"confidence": "1.000",
			"name": "from",
			"time": "53.76"
		},
		{
			"duration": "0.19",
			"confidence": "0.710",
			"name": "there",
			"time": "53.96"
		},
		{
			"duration": "0.07",
			"confidence": "0.890",
			"name": ".",
			"time": "54.15"
		},
		{
			"duration": "0.07",
			"confidence": "0.840",
			"name": "I",
			"time": "54.73"
		},
		{
			"duration": "0.18",
			"confidence": "0.770",
			"name": "just",
			"time": "54.80"
		},
		{
			"duration": "0.18",
			"confidence": "0.770",
			"name": "need",
			"time": "54.99"
		},
		{
			"duration": "0.07",
			"confidence": "0.670",
			"name": "a",
			"time": "55.18"
		},
		{
			"duration": "0.53",
			"confidence": "0.990",
			"name": "change",
			"time": "55.26"
		},
		{
			"duration": "0.02",
			"confidence": "0.590",
			"name": ".",
			"time": "55.79"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "And",
			"time": "59.12"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "59.60"
		},
		{
			"duration": "0.27",
			"confidence": "0.990",
			"name": "need",
			"time": "59.69"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "a",
			"time": "59.96"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "way",
			"time": "60.05"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "to",
			"time": "60.29"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "express",
			"time": "60.53"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "myself",
			"time": "60.98"
		},
		{
			"duration": "0.92",
			"confidence": "0.840",
			"name": ".",
			"time": "61.79"
		},
		{
			"duration": "0.39",
			"confidence": "0.350",
			"name": "Mineau",
			"time": "65.51"
		},
		{
			"duration": "0.17",
			"confidence": "0.760",
			"name": "put",
			"time": "67.59"
		},
		{
			"duration": "0.07",
			"confidence": "0.460",
			"name": "it",
			"time": "67.84"
		},
		{
			"duration": "0.19",
			"confidence": "1.000",
			"name": "on",
			"time": "67.97"
		},
		{
			"duration": "0.18",
			"confidence": "0.750",
			"name": "other",
			"time": "68.17"
		},
		{
			"duration": "0.50",
			"confidence": "1.000",
			"name": "people",
			"time": "68.36"
		},
		{
			"duration": "0.30",
			"confidence": "0.990",
			"name": "people",
			"time": "71.02"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "want",
			"time": "71.32"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "to",
			"time": "71.47"
		},
		{
			"duration": "0.26",
			"confidence": "1.000",
			"name": "watch",
			"time": "71.56"
		},
		{
			"duration": "0.28",
			"confidence": "0.990",
			"name": "video",
			"time": "71.83"
		},
		{
			"duration": "0.14",
			"confidence": "0.950",
			"name": "or",
			"time": "72.11"
		},
		{
			"duration": "0.10",
			"confidence": "0.420",
			"name": "they",
			"time": "72.25"
		},
		{
			"duration": "0.24",
			"confidence": "0.910",
			"name": "want",
			"time": "72.34"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "to",
			"time": "72.58"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "watch",
			"time": "72.64"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "it",
			"time": "72.94"
		},
		{
			"duration": "0.32",
			"confidence": "0.710",
			"name": "and",
			"time": "73.92"
		},
		{
			"duration": "0.11",
			"confidence": "0.920",
			"name": "they",
			"time": "74.31"
		},
		{
			"duration": "0.15",
			"confidence": "0.500",
			"name": "could",
			"time": "74.44"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "stop",
			"time": "74.59"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "whenever",
			"time": "74.86"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "they",
			"time": "75.10"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "want",
			"time": "75.22"
		},
		{
			"duration": "0.03",
			"confidence": "0.930",
			"name": ".",
			"time": "75.55"
		},
		{
			"duration": "0.06",
			"confidence": "0.600",
			"name": "You",
			"time": "78.76"
		},
		{
			"duration": "0.26",
			"confidence": "0.600",
			"name": "know",
			"time": "79.23"
		},
		{
			"duration": "0.20",
			"confidence": "0.620",
			"name": "this",
			"time": "79.96"
		},
		{
			"duration": "0.11",
			"confidence": "1.000",
			"name": "if",
			"time": "80.27"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "you",
			"time": "80.38"
		},
		{
			"duration": "0.21",
			"confidence": "0.940",
			"name": "tell",
			"time": "80.44"
		},
		{
			"duration": "0.26",
			"confidence": "1.000",
			"name": "someone",
			"time": "80.65"
		},
		{
			"duration": "0.10",
			"confidence": "0.500",
			"name": "in",
			"time": "80.91"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "person",
			"time": "81.01"
		},
		{
			"duration": "0.08",
			"confidence": "0.970",
			"name": "they",
			"time": "81.46"
		},
		{
			"duration": "0.23",
			"confidence": "0.530",
			"name": "kind",
			"time": "81.54"
		},
		{
			"duration": "0.09",
			"confidence": "0.530",
			"name": "of",
			"time": "81.81"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "go",
			"time": "82.15"
		},
		{
			"duration": "0.17",
			"confidence": "0.850",
			"name": "hey",
			"time": "82.45"
		},
		{
			"duration": "0.30",
			"confidence": "0.940",
			"name": "will",
			"time": "82.63"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "stop",
			"time": "82.93"
		},
		{
			"duration": "0.06",
			"confidence": "0.590",
			"name": ".",
			"time": "83.23"
		},
		{
			"duration": "0.09",
			"confidence": "0.980",
			"name": "You",
			"time": "83.32"
		},
		{
			"duration": "0.22",
			"confidence": "0.750",
			"name": "tell",
			"time": "83.41"
		},
		{
			"duration": "0.20",
			"confidence": "1.000",
			"name": "me",
			"time": "83.63"
		},
		{
			"duration": "0.18",
			"confidence": "0.960",
			"name": "too",
			"time": "83.83"
		},
		{
			"duration": "0.45",
			"confidence": "0.960",
			"name": "much",
			"time": "84.01"
		},
		{
			"duration": "0.46",
			"confidence": "0.540",
			"name": ".",
			"time": "84.46"
		},
		{
			"duration": "0.50",
			"confidence": "0.980",
			"name": "And",
			"time": "85.46"
		},
		{
			"duration": "0.04",
			"confidence": "0.670",
			"name": "at",
			"time": "87.07"
		},
		{
			"duration": "0.22",
			"confidence": "0.690",
			"name": "least",
			"time": "87.21"
		},
		{
			"duration": "0.10",
			"confidence": "0.610",
			"name": "for",
			"time": "87.46"
		},
		{
			"duration": "0.14",
			"confidence": "0.640",
			"name": "the",
			"time": "87.60"
		},
		{
			"duration": "0.52",
			"confidence": "0.930",
			"name": "video",
			"time": "87.74"
		},
		{
			"duration": "0.12",
			"confidence": "0.980",
			"name": "you",
			"time": "89.49"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "get",
			"time": "89.61"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "sick",
			"time": "89.85"
		},
		{
			"duration": "0.29",
			"confidence": "0.950",
			"name": "even",
			"time": "90.33"
		},
		{
			"duration": "0.15",
			"confidence": "0.360",
			"name": "those",
			"time": "90.62"
		},
		{
			"duration": "0.36",
			"confidence": "0.440",
			"name": "dumb",
			"time": "90.79"
		},
		{
			"duration": "0.35",
			"confidence": "0.710",
			"name": "pulls",
			"time": "91.32"
		},
		{
			"duration": "0.13",
			"confidence": "0.730",
			"name": "it",
			"time": "91.68"
		},
		{
			"duration": "0.21",
			"confidence": "0.540",
			"name": "out",
			"time": "91.82"
		},
		{
			"duration": "0.08",
			"confidence": "0.780",
			"name": ".",
			"time": "92.04"
		},
		{
			"duration": "0.48",
			"confidence": "0.850",
			"name": "Hopefully",
			"time": "94.56"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "this",
			"time": "95.10"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "will",
			"time": "95.34"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "be",
			"time": "95.46"
		},
		{
			"duration": "0.03",
			"confidence": "0.990",
			"name": "a",
			"time": "96.63"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "good",
			"time": "96.66"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "opportunity",
			"time": "96.90"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "to",
			"time": "97.50"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "find",
			"time": "97.59"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "out",
			"time": "97.92"
		},
		{
			"duration": "0.22",
			"confidence": "0.920",
			"name": "more",
			"time": "98.04"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "about",
			"time": "99.00"
		},
		{
			"duration": "0.48",
			"confidence": "0.990",
			"name": "myself",
			"time": "99.27"
		},
		{
			"duration": "0.03",
			"confidence": "0.930",
			"name": ".",
			"time": "99.75"
		},
		{
			"duration": "0.09",
			"confidence": "0.710",
			"name": "And",
			"time": "100.92"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "101.18"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "learn",
			"time": "101.30"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "how",
			"time": "102.14"
		},
		{
			"duration": "0.17",
			"confidence": "0.910",
			"name": "other",
			"time": "102.41"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "people",
			"time": "102.59"
		},
		{
			"duration": "0.27",
			"confidence": "0.860",
			"name": "see",
			"time": "103.01"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "me",
			"time": "103.28"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "103.55"
		},
		{
			"duration": "0.47",
			"confidence": "0.580",
			"name": "Or",
			"time": "108.39"
		},
		{
			"duration": "0.24",
			"confidence": "0.920",
			"name": "is",
			"time": "108.98"
		},
		{
			"duration": "0.15",
			"confidence": "0.950",
			"name": "the",
			"time": "109.22"
		},
		{
			"duration": "0.49",
			"confidence": "0.990",
			"name": "future",
			"time": "109.37"
		},
		{
			"duration": "0.19",
			"confidence": "0.580",
			"name": ".",
			"time": "109.86"
		}
	],
	"format": "1.0"
};


//////////////////
// WEBPACK FOOTER
// ./src/video_diary.json
// module id = 31
// module chunks = 0